<form [formGroup]="reasonForm()">
    <div class="ap-flex ap-gap-gt-md-4 ap-flex-lt-lg-wrap">
        <div class="ap-flex-basis-50 ap-flex-lt-lg-fill">
            <p class="tertiary">{{ 'reason.sub_header' | apContent }}</p>
            <ap-dropdown
                data-bb="ReasonDropdown"
                label="{{ 'reason.default' | apContent }}"
                formControlName="reason"
                [options]="reasonOptions"
                [messages]="getErrorMessage('reason.sub_header')"
            >
            </ap-dropdown>
        </div>

        @if (showHouseReasonDropdown) {
            <div class="ap-flex-basis-50 ap-flex-lt-lg-fill">
                <p class="tertiary">{{ 'reason.housing.header' | apContent }}</p>
                <ap-dropdown
                    data-bb="HouseReasonDropdown"
                    label="{{ 'reason.default' | apContent }}"
                    formControlName="houseReason"
                    [options]="houseReasonOptions"
                    [messages]="getErrorMessage('reason.housing.header')"
                >
                </ap-dropdown>
            </div>
        }
        @if (showRefinanceRadio) {
            <div class="ap-flex-basis-50 ap-flex-lt-lg-fill">
                <p class="secondary">{{ 'reason.refinance.header' | apContent }}</p>
                <ap-radio-group
                    data-bb="refinanceRadioGroup"
                    [control]="reasonForm().controls.refinance"
                    [inline]="true"
                    [description]="'reason.refinance.header' | apContent"
                    [descriptionHidden]="true"
                    [messages]="getErrorMessage('reason.refinance.header')"
                >
                    <ap-radio-button
                        data-bb="refinanceRadioButton"
                        label="{{ 'answer.label.true' | apContent }}"
                        name="mortgageRadioButton"
                        [value]="true"
                        [formControl]="reasonForm().controls.refinance"
                    >
                    </ap-radio-button>
                    <ap-radio-button
                        data-bb="refinanceRadioButton"
                        label="{{ 'answer.label.false' | apContent }}"
                        name="mortgageRadioButton"
                        [value]="false"
                        [formControl]="reasonForm().controls.refinance"
                    >
                    </ap-radio-button>
                </ap-radio-group>
            </div>
        }
    </div>
</form>
